import React from 'react';

/**@type {React.Context<import('../../types').IPageData>} */
import { jsx as _jsx } from "react/jsx-runtime";
const pageDataContext = /*#__PURE__*/React.createContext(undefined);
function _PageDataContainer(_ref) {
  let {
    children,
    data
  } = _ref;
  const memoizedData = React.useMemo(() => data, [data]);
  return /*#__PURE__*/_jsx(pageDataContext.Provider, {
    value: memoizedData,
    children: children
  });
}
function usePageData() {
  const ctx = React.useContext(pageDataContext);
  if (!ctx) {
    throw new Error('usePageData must be used within a PageDataContainer');
  }
  return ctx;
}
const PageDataContainer = /*#__PURE__*/React.memo(_PageDataContainer);
export { PageDataContainer, usePageData };